
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(18076|35761|44743|46903|54065|5577|76368|86974|93182|95117)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
